export { default as OnHoldBadge } from './OnHoldBadge';
